<template>
  <div class="the-navbar__user-meta flex items-center" v-if="user.id">

    <div class="text-right leading-tight hidden sm:block">
      <p class="font-semibold">{{ user.last_name ? user.last_name : '' }} {{ user.first_name ? user.first_name : '' }}</p>
      <small>{{ user.profile == '1' ? 'Agent' : 'Administrateur' }}</small>
    </div>

    <vs-dropdown vs-custom-content vs-trigger-click class="cursor-pointer">

      <div class="con-img ml-3">
        <img v-if="user.photo" key="onlineImg" :src="user.photo" alt="user-img" width="40" height="40" class="rounded-full shadow-md cursor-pointer block" />
      </div>

      <vs-dropdown-menu class="vx-navbar-dropdown">
        <ul style="min-width: 9rem">
          <li @click="$router.push({name: 'profile'})"
            class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white">
            <feather-icon icon="UserIcon" svgClasses="w-4 h-4" />
            <span class="ml-2">Profil</span>
          </li>
          <vs-divider class="m-1" />
          <li
            class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white"
            @click="logout">
            <feather-icon icon="LogOutIcon" svgClasses="w-4 h-4" />
            <span class="ml-2">Déconnexion</span>
          </li>
        </ul>
      </vs-dropdown-menu>
    </vs-dropdown>
  </div>
</template>

<script>
import auth from '../../../../helper/auth'
import { EventBus } from '@/helper/helper'
export default {
  data() {
    return {
      user: {}
    }
  },
  computed: {

  },
  mounted(){
    this.user = this.getUser()
    EventBus.$on('updateProfile', this.updateProfileFunction)
  },
  methods: {
    updateProfileFunction(data){
      this.user = data
    },
    getUser(){
      let item = localStorage.getItem('user_cnhu')
      if (item !== null){
        let user = JSON.parse(item);
        return user;
      }
      return {};
    },
    logout() {
      this.$vs.loading();
      this.$http
        .post("auth/logout")
        .then((response) => {
          if (response.data.status){
            this.$vs.loading.close()
            auth.logout()
            this.$router.push('/login').catch(() => {})
          }
        })
        .catch(() => {
          this.$vs.loading.close();
          auth.logout()
          this.$router.push('/login').catch(() => {})
        });
    },
  }
}
</script>
